import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from "react";
import LiveMapcomponent from "../LiveTrack/LiveMapcomponent";
import {
  Badge,
  Card,
  Checkbox,
  Col,
  Collapse,
  Form,
  Row,
  Input,
  Spin,
  message,
  Tooltip,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styled from "styled-components";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import FilterIcon from "../../assets/images/Filter-Icon.svg";
import { Tab } from "../../Reusablecomponents/Tab";
import { ReactComponent as LiveTrackTwo } from "../../assets/livetracking/livetracktwo.svg";
import { ReactComponent as LiveTrackThree } from "../../assets/livetracking/livetrackthree.svg";
import { ReactComponent as LiveTrackFour } from "../../assets/livetracking/livetrackfour.svg";
import { ReactComponent as LiveTrackFive } from "../../assets/livetracking/livetrackfive.svg";
import { ReactComponent as LiveTrackSix } from "../../assets/livetracking/livetracksix.svg";
import { ReactComponent as LiveTrackSeven } from "../../assets/livetracking/livetrackseven.svg";
import { ReactComponent as LiveTrackEight } from "../../assets/livetracking/livvetrackingeight.svg";
import { ReactComponent as LiveTracknine } from "../../assets/livetracking/livetrackingnine.svg";
import { ReactComponent as LiveTrackten } from "../../assets/livetracking/livetrackingten.svg";
import { ReactComponent as LiveTrackone } from "../../assets/livetracking/livetrackone.svg";
import { ReactComponent as LiveTrackeleven } from "../../assets/livetracking/trackwrighteleven.svg";
import { ReactComponent as LiveTracksixteen } from "../../assets/livetracking/trackrightsixteen.svg";
import { ReactComponent as LiveTrackthirteen } from "../../assets/livetracking/trackrightthirteen.svg";
import { ReactComponent as LiveTracktwelve } from "../../assets/livetracking/trackwrighttwelve.svg";
import { ReactComponent as LiveTrackfourteen } from "../../assets/livetracking/trackrightfourteen.svg";
import { ReactComponent as Stationary } from "../../../src/assets/images/stationary.svg";
import { ReactComponent as Moving } from "../../../src/assets/images/Movement Status.svg";
import { ReactComponent as Idle } from "../../../src/assets/images/idle.svg";
import { ReactComponent as LowBt } from "../../../src/assets/images/low-bt.svg";
import { ReactComponent as Battery } from "../../../src/assets/images/Vector (2).svg";
import { ReactComponent as Locked } from "../../../src/assets/images/locked.svg";
import { ReactComponent as UnLocked } from "../../../src/assets/images/unlocked.svg";
import { ReactComponent as Batteryicon } from "../../assets/images/gg_battery.svg";
import { useDispatch, useSelector } from "react-redux";
import { CALL_API } from "../../Common/api";
import { ReactComponent as GKPM } from "../../../src/assets/images/GKPM.svg";
import { ReactComponent as Drop } from "../../../src/assets/images/drop.svg";
import { ReactComponent as GArrow } from "../../../src/assets/images/GArrow.svg";
import { ReactComponent as MovingVehicle } from "../../assets/images/MovingVehicle.svg";
import { ReactComponent as StationaryVehicle } from "../../assets/images/StationaryVehicle.svg";
import { ReactComponent as IdleVehicle } from "../../assets/images/Idlevehicle.svg";
import { CSVLink } from "react-csv";
// import DraggablePopup from "../../components/Popup/DraggablePopup";

export const LiveTrackStyle = styled.div`
  body {
    overflow: hidden;
  }

  .container_three {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    margin-bottom: 25px;
    margin-top: 10px;
    flex-shrink: 0;
    position: relative;
    z-index: 100;
  }

  .ant-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .ant-tabs-nav {
    flex-shrink: 0;
    margin-bottom: 16px;
  }

  .ant-tabs-content-holder {
    overflow: hidden;
    flex: 1;
    min-height: 0;
  }

  .ant-tabs-content {
    height: 100%;
  }

  .ant-tabs-tabpane {
    height: 100%;
  }

  .custom_dashboard_ai {
    height: auto;
    max-height: calc(100vh - 330px);
    display: flex;
    flex-direction: column;
  }

  .custom_dashboard_ai_tab {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .map_container_hierarchy {
    max-height: calc(100vh - 330px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;
    padding-bottom: 10px;
    box-sizing: border-box;
  }

  .liveTrackMap_container_two {
    width: 100%;
    height: 100vh;
    position: relative;
  }

  .card_container {
    width: 430px;
    min-width: 430px;
    max-width: 430px;
    max-height: calc(100vh - 110px) !important;
    min-height: calc(100vh - 110px) !important;
    position: absolute;
    top: 10px;
    left: 20px;
    z-index: 20;
    background-color: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
  }

  .ant-card-bordered {
    border: none !important;
    border-radius: 18px !important;
  }

  .ant-card .ant-card-body {
    padding: 12px !important;
    overflow: visible;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .left-section {
    flex: 1;
  }

  .right-section {
    margin-left: auto;
    position: relative;
    z-index: 1000;
  }

  .map_container_checkboxsubcontainer {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    flex-shrink: 0;
  }

  .mapbox_online_icon {
    color: green;
  }

  .IconStyle {
    margin-left: 34px;
    margin-top: 10px;
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .IconSize {
    width: 20px;
    height: 20px;
  }

  .IconSizecontainer {
    width: 17px;
    height: 17px;
  }

  .StatusWrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  .StatusWrapper:hover .StatusTooltip {
    display: block;
  }

  .StatusTooltip {
    display: none;
    position: absolute;
    left: 100%;
    margin-left: 8px;
    font-size: 13px;
    white-space: nowrap;
    pointer-events: none;
    color: #b7b7b7;
  }

  .Iconbg {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .filter-popup {
    position: absolute;
    left: 100%;
    top: 0;
    margin-left: 10px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 25px;
    padding: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 200px;
  }

  .filter-option {
    padding: 8px 14px;
    border-radius: 25px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.3s;
  }

  .filter-option.active {
    background-color: green;
    color: #fff;
  }

  .filter-option:not(.active) {
    background-color: #fff;
    color: #333;
  }

  .filter-option:not(.active):hover {
    background-color: #2c963d;
    color: #fff;
  }

  .tab-content-wrapper {
    min-height: calc(100vh - 180px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .no-results-message {
    text-align: center;
    padding: 20px;
    color: #999;
  }

  .company-node {
    cursor: pointer;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #e8ffec;
    border-radius: 4px;
    margin-bottom: 4px;
    transition: background 0.2s ease;
    user-select: none;
  }

  .company-node.bold {
    font-weight: bold;
  }

  .company-node:hover {
    background-color: #d4f5da;
  }

  .subcompany-node {
    cursor: pointer;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #f1f1f1;
    border-radius: 4px;
    margin-bottom: 4px;
    transition: background 0.2s ease;
    user-select: none;
  }

  .subcompany-node:hover {
    background-color: #e8e8e8;
  }

  .node-name {
    flex: 1;
  }

  .arrow-icon {
    width: 12px;
    height: 12px;
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);
    margin-left: auto;
  }

  .arrow-icon.expanded {
    transform: rotate(0deg);
  }

  .arrow-icon.collapsed {
    transform: rotate(-90deg);
  }

  .vehicle-list {
    margin-left: 30px;
  }

  .vehicle-item {
    margin-bottom: 10px;
  }

  .vehicle-header {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 5px;
  }

  .vehicle-name {
    font-weight: bold;
  }

  .vehicle-details {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: 30px;
    font-size: 13px;
    color: #555;
  }

  .separator {
    color: #ccc;
  }

  .vehicle-divider {
    border: none;
    border-top: 1px solid #e0e0e0;
    margin: 10px 0;
  }

  .battery-display {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .battery-text {
    font-size: 12px;
  }

  .lock-display {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .status-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 6px;
  }

  .search-input {
    width: 350px;
    height: 50px;
  }

  .company-icon {
    width: 20px;
    height: 20px;
  }

  .subcompany-icon {
    width: 16px;
    height: 16px;
  }

  .filter-icon-img {
    fill: #acacac;
    width: 35px;
    height: 35px;
  }
`;

const LiveTrack = () => {
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [Monitorcount, setMonitorcount] = useState([]);
  const [Filtercount, setFiltercount] = useState([]);
  const [JtVehicleDetails, setJtVehicleDetails] = useState([]);
  const [JtDeviceDetails, setJtDeviceDetails] = useState([]);
  const [AllAssetList, setAllAssetList] = useState([]);
  const [VehLivedetails, setVehLiveDetails] = useState([]);
  const [DeviceLiveDetails, setDeviceLiveDetails] = useState([]);
  const [activeTab, setActiveTab] = useState("All");
  const [selectedFGUID, setSelectedFGUID] = useState("");
  const [selectedFGUIDs, setSelectedFGUIDs] = useState([]);
  const [expandedNodes, setExpandedNodes] = useState({});
  const [filterVisible, setFilterVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [handleLoading, setHandleLoading] = useState(false);
  const [MonitorDetails, setMonitorDetails] = useState([]);
  const [statusMap, setStatusMap] = useState({});
  const [isInitialSelectionDone, setIsInitialSelectionDone] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [selectedVehicleFromList, setSelectedVehicleFromList] = useState(null);
  const [vehicleSelectionCounter, setVehicleSelectionCounter] = useState(0);
  const [visibleFGUIDs, setVisibleFGUIDs] = useState([]);
  const defaultExpandedDoneRef = useRef(false);
  const subscriptionList = useSelector(
    (state) => state?.authTracking?.subscriptionList,
  );
  const [hoveredVehicle, setHoveredVehicle] = useState(null);
  const vehicleRefs = useRef({});
  const scrollNodesRef = useRef({});
  const scrollPositionsRef = useRef({});
  const filterRef = useRef(null);
  const filterToggleRef = useRef(null);

  const toggleExpand = useCallback((key) => {
    setExpandedNodes((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  }, []);

  const expandAllNodes = useCallback((nodes) => {
    const allKeys = {};

    const collectKeys = (nodeList) => {
      nodeList.forEach((node) => {
        if (
          node.type === "company" ||
          node.type === "subCompany" ||
          node.type === "subSubCompany"
        ) {
          allKeys[node.key] = true;
        }
        if (node.children && node.children.length > 0) {
          collectKeys(node.children);
        }
      });
    };

    collectKeys(nodes);
    setExpandedNodes(allKeys);
  }, []);

  const saveScrollForTab = useCallback((tabKey) => {
    const node = scrollNodesRef.current[tabKey];
    if (node) scrollPositionsRef.current[tabKey] = node.scrollTop;
  }, []);

  const restoreScrollForTab = useCallback((tabKey) => {
    const node = scrollNodesRef.current[tabKey];
    const pos = scrollPositionsRef.current[tabKey] ?? 0;
    if (node) {
      requestAnimationFrame(() => {
        node.scrollTop = pos;
      });
    }
  }, []);

  const setScrollNode = useCallback(
    (tabKey) => (el) => {
      if (el) {
        scrollNodesRef.current[tabKey] = el;
        const pos = scrollPositionsRef.current[tabKey];
        if (typeof pos === "number") {
          requestAnimationFrame(() => {
            el.scrollTop = pos;
          });
        }
      } else {
        delete scrollNodesRef.current[tabKey];
      }
    },
    [],
  );

  const getVehicleStatus = useCallback((item, offlineThresholdMinutes = 10, isCargoDevice = false) => {
    if (!item) return "Inactivated";

    const { Lon, Lat, Speed = 0, Lock, Vehicle, RT } = item;
    const acc = Vehicle?.ACC ?? null;
    const lockStatus = Lock?.LS;

    if (!RT) return "Inactivated";

    // For cargo devices (JT701D): check offline FIRST before lock status
    if (isCargoDevice) {
      const lastUpdate = new Date(RT).getTime();
      if (isNaN(lastUpdate)) return "Inactivated";
      const diffMinutes = (Date.now() - lastUpdate) / (1000 * 60);
      if (diffMinutes > offlineThresholdMinutes) return "Offline";
      if (lockStatus === 0) return "Locked";
      if (lockStatus === 1) return "Unlocked";
      if (!Lon || !Lat || Lon === 0 || Lat === 0) return "NotPositioned";
      if (Speed !== 0) return "Moving";
      if (acc !== null && acc !== 0 && Speed === 0) return "Idle";
      if (acc === 0 && Speed === 0) return "Stationary";
      return "UnknownStatus";
    }

    // Original logic unchanged for All tab and TrackRight AI (GP2000)
    if (lockStatus === 0) return "Locked";
    if (lockStatus === 1) return "Unlocked";

    const lastUpdate = new Date(RT).getTime();
    if (isNaN(lastUpdate)) return "Inactivated";

    const now = Date.now();
    const diffMinutes = (now - lastUpdate) / (1000 * 60);

    if (diffMinutes > offlineThresholdMinutes) return "Offline";
    if (!Lon || !Lat || Lon === 0 || Lat === 0) return "NotPositioned";
    if (Speed !== 0) return "Moving";
    if (acc !== null && acc !== 0 && Speed === 0) return "Idle";
    if (acc === 0 && Speed === 0) return "Stationary";

    return "UnknownStatus";
  }, []);

  const getFilterCounts = useCallback(
    (data, isCargoDevice = false) => {  // ← add param
      if (!data || data.length === 0) return {};

      let counts = {
        All: data.length,
        Moving: 0, Idle: 0, Stationary: 0,
        NotPositioned: 0, Locked: 0, Unlocked: 0,
        Offline: 0, Inactivated: 0,
      };

      data.forEach((item) => {
        const status = getVehicleStatus(item, 10, isCargoDevice); // ← pass flag
        if (counts[status] !== undefined) counts[status]++;
      });

      counts.FOnline = counts.All - (counts.Offline + counts.Inactivated);
      counts.FOffline = counts.Offline;

      return counts;
    },
    [getVehicleStatus],
  );

  // Collect vehicle IDs that belong to the current tab's hierarchy
  const tabScopedVehicleIds = useMemo(() => {
    const ids = new Set();
    if (!JtVehicleDetails?.data) return ids;

    const isTabVehicle = (fcar) => {
      if (activeTab === "TrackRight AI") return fcar?.TName === "GP2000";
      if (activeTab === "TrackRight AI Cargo") return fcar?.TName === "JT701D";
      return true;
    };

    const walk = (nodes) => {
      nodes.forEach((node) => {
        // Always recurse regardless of FNType
        if (node.FChild?.length) walk(node.FChild);
        // Collect vehicle IDs at leaf level
        if (node.FNType === 2 && node.FCar && isTabVehicle(node.FCar)) {
          if (node.FCar.ID !== undefined && node.FCar.ID !== null) {
            ids.add(String(node.FCar.ID));
          }
        }
      });
    };

    walk(JtVehicleDetails.data);
    return ids;
  }, [JtVehicleDetails, activeTab]);

  // Also update tabScopedMonitorDetails to match with String():
  const tabScopedMonitorDetails = useMemo(() => {
    return MonitorDetails.filter((m) => tabScopedVehicleIds.has(String(m.ID)));
  }, [MonitorDetails, tabScopedVehicleIds]);

  // Counts total vehicles directly from raw hierarchy data per tab
  // This matches exactly what recomputeNodeCounts shows in the node labels
  const tabHierarchyVehicleCount = useMemo(() => {
    if (!JtVehicleDetails?.data) return 0;

    const isTabVehicle = (fcar) => {
      if (activeTab === "TrackRight AI") return fcar?.TName === "GP2000";
      if (activeTab === "TrackRight AI Cargo") return fcar?.TName === "JT701D";
      return true; // "All" — count everything
    };

    let count = 0;
    const seenIds = new Set(); // avoid double-counting duplicates

    const walk = (nodes) => {
      nodes.forEach((node) => {
        if (node.FNType === 2 && node.FCar && isTabVehicle(node.FCar)) {
          const carId = node.FCar?.ID;
          if (carId !== undefined && carId !== null && !seenIds.has(carId)) {
            seenIds.add(carId);
            count++;
          }
        } else if (node.FNType === 2 && activeTab === "All") {
          count++;
        }
        if (node.FChild?.length) walk(node.FChild);
      });
    };

    walk(JtVehicleDetails.data);
    return count;
  }, [JtVehicleDetails, activeTab]);

  const tabScopedFilterCount = useMemo(() => {
    const isCargoTab = activeTab === "TrackRight AI Cargo";

    const counts = getFilterCounts(tabScopedMonitorDetails, isCargoTab);

    const seenIds = new Set(tabScopedMonitorDetails.map((m) => String(m.ID)));
    const absentCount = [...tabScopedVehicleIds].filter(
      (id) => !seenIds.has(id)
    ).length;

    if (absentCount > 0) {
      counts.Offline = (counts.Offline || 0) + absentCount;
      counts.FOffline = counts.Offline;

      // FIX: All must include absent vehicles before recalculating FOnline
      // Without this, FOnline = (too-small All) - Offline = wrong negative/low value
      const totalAll = (counts.All || 0) + absentCount;
      counts.FOnline = totalAll - counts.Offline - (counts.Inactivated || 0);
    }

    return counts;
  }, [tabScopedMonitorDetails, tabScopedVehicleIds, getFilterCounts, activeTab]);
  
  // Update tabScopedStatusCounts to pass isCargoDevice flag
  const tabScopedStatusCounts = useMemo(() => {
  const total = tabHierarchyVehicleCount;
  const isCargoTab = activeTab === "TrackRight AI Cargo";

  let online = 0, offline = 0, moving = 0;
  const seenIds = new Set();

  tabScopedMonitorDetails.forEach((item) => {
    seenIds.add(String(item.ID));
    const st = getVehicleStatus(item, 10, isCargoTab);
    if (st === "Offline" || st === "Inactivated") offline++;
    else online++;
    if (st === "Moving") moving++;
  });

  // Vehicles in hierarchy but completely absent from MonitorDetails = Offline
  // Use tabScopedVehicleIds instead of (total - length) to avoid double-counting
  const absentCount = [...tabScopedVehicleIds].filter(
    (id) => !seenIds.has(id)
  ).length;
  offline += absentCount;

  return { total, online, offline, moving };
}, [
  tabHierarchyVehicleCount,
  tabScopedMonitorDetails,
  tabScopedVehicleIds,
  getVehicleStatus,
  activeTab,
]);

  const filters = useMemo(
    () => [
      { key: "Offline", count: tabScopedFilterCount?.FOffline ?? 0 },
      { key: "Online", count: tabScopedFilterCount?.FOnline ?? 0 },
      { key: "Moving", count: tabScopedFilterCount?.Moving ?? 0 },
      { key: "Stationary", count: tabScopedFilterCount?.Stationary ?? 0 },
      { key: "Idle", count: tabScopedFilterCount?.Idle ?? 0 },
      { key: "NotPositioned", count: tabScopedFilterCount?.NotPositioned ?? 0 },
      { key: "Locked", count: tabScopedFilterCount?.Locked ?? 0 },
      { key: "Unlocked", count: tabScopedFilterCount?.Unlocked ?? 0 },
    ],
    [tabScopedFilterCount],
  );

  const toggleFilter = useCallback((key) => {
    setSelectedFilters((prev) => {
      if (prev.includes(key)) {
        return [];
      } else {
        return [key];
      }
    });
  }, []);

  const getAllVehicleFGUIDs = useCallback((node) => {
    let ids = [];
    if (node.type === "vehicle") {
      ids.push(node.FGUID);
    }
    if (node.vehicles && node.vehicles.length > 0) {
      ids = ids.concat(node.vehicles.map((v) => v.FGUID));
    }
    if (node.children && node.children.length > 0) {
      node.children.forEach((child) => {
        ids = ids.concat(getAllVehicleFGUIDs(child));
      });
    }
    return ids;
  }, []);

  const chunkArray = useCallback((arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }, []);

  const handleVehicleCheckbox = useCallback(
    async (FGUID, checked) => {
      const currentSelected = selectedFGUIDs;
      const newSelected = checked
        ? [...currentSelected, FGUID]
        : currentSelected.filter((id) => id !== FGUID);
      setSelectedFGUIDs(newSelected);

      // Only fetch monitor data when checking, not when unchecking
      if (checked) {
        setHandleLoading(true);
        try {
          await fetchMonitorDevice([FGUID]);
        } catch (error) {
          setSelectedFGUIDs(currentSelected);
        } finally {
          setHandleLoading(false);
        }
      }
    },
    [selectedFGUIDs],
  );
  const handleCompanyCheckbox = useCallback(
    async (node, checked) => {
      const currentSelected = selectedFGUIDs;
      const allFGUIDs = getAllVehicleFGUIDs(node);
      const newSelected = checked
        ? Array.from(new Set([...currentSelected, ...allFGUIDs]))
        : currentSelected.filter((id) => !allFGUIDs.includes(id));

      setExpandedNodes((prev) => ({
        ...prev,
        [node.key]: true,
      }));
      setSelectedFGUIDs(newSelected);
      setHandleLoading(true);

      try {
        await fetchMonitorDevice(allFGUIDs);
      } catch (error) {
        setSelectedFGUIDs(currentSelected);
      } finally {
        setHandleLoading(false);
      }
    },
    [selectedFGUIDs, getAllVehicleFGUIDs],
  );

  const dashboardCount = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "POST",
        "ai/trackinglink/dashboardCount",
        {
          FAgentGUID: userInfo?.ECTSCompId || "",
        },
      );
      setMonitorcount(data);
    } catch (error) {
      console.error("Dashboard count error:", error);
    } finally {
      setLoading(false);
    }
  }, [userInfo]);

  const jointechVehicledetails = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "POST",
        "ai/trackinglink/allcompanyAssetList",
        {
          FAgentGUID: userInfo?.ECTSCompId || "",
        },
      );
      setJtVehicleDetails(data);
    } catch (error) {
      console.error("Vehicle details error:", error);
    } finally {
      setLoading(false);
    }
  }, [userInfo]);

  const jointechDevicedetails = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "POST",
        "ai/trackinglink/allcompanyDeviceList",
        {
          FAgentGUID: userInfo?.ECTSCompId || "",
        },
      );
      setJtDeviceDetails(data);
    } catch (error) {
      console.error("Device details error:", error);
    } finally {
      setLoading(false);
    }
  }, [userInfo]);

  const fetchAllDetails = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        "ai/trackinglink/AllAssetInformation",
      );
      setAllAssetList(data || []);
    } catch (error) {
      console.error("Asset information error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const vehicleLiveLocation = useCallback(
    async (FGUID) => {
      try {
        setLoading(true);
        const { data } = await CALL_API(
          "POST",
          "/ai/trackinglink/RealTimeVehicleLocation",
          {
            FGUIDs: Array.isArray(FGUID) ? FGUID.join(",") : FGUID,
          },
        );

        const vehicleLiveDetails = data || [];
        const vehicleDetailsWithDriver = vehicleLiveDetails.map((vehicle) => {
          const driver = AllAssetList.find(
            (asset) => asset.FGUID === vehicle.FVehicleGUID,
          );
          return {
            ...vehicle,
            driverName: driver ? driver.FDriverName : "Driver not found",
            phonenumber: driver
              ? driver.FDriverPhoneNumber
              : "Phonenumber not found",
          };
        });
        setVehLiveDetails(vehicleDetailsWithDriver);
      } catch (error) {
        console.error("Vehicle live location error:", error);
      } finally {
        setLoading(false);
      }
    },
    [AllAssetList],
  );

  const fetchMonitorDevice = useCallback(
    async (assetGUIDs) => {
      if (!assetGUIDs || assetGUIDs.length === 0) return;

      setLoading(true);
      try {
        const chunkSize = 50;
        const chunks = chunkArray(assetGUIDs, chunkSize);
        let allData = [];

        for (const chunk of chunks) {
          const payload = { assetGUIDs: chunk.join(",") };
          const { data: response } = await CALL_API(
            "POST",
            "ai/trackinglink/MonitorDevice",
            payload,
          );
          const chunkData = response?.data || [];
          if (chunkData.length) {
            allData = [...allData, ...chunkData];
          }
        }

        setMonitorDetails(allData);
      } catch (error) {
        console.error("Monitor device error:", error);
      } finally {
        setLoading(false);
      }
    },
    [chunkArray],
  );

  const filterHierarchyByStatus = useCallback(
    (nodes, selectedFilter) => {
      if (!selectedFilter || selectedFilter.length === 0) return nodes;

      const targetStatus = selectedFilter[0];
      const onlineIdSet = new Set();

      if (targetStatus === "Online") {
        MonitorDetails.forEach((item) => {
          // Determine if this item is a cargo device by checking if its ID
          // exists in the JT701D set — use the existing tabScopedVehicleIds
          // but we can't access it here, so check Lock field as proxy:
          // Actually, simplest: check both status logics and union them
          const stDefault = getVehicleStatus(item, 10, false);
          const stCargo = getVehicleStatus(item, 10, true);
          const isCargoItem = item.Lock !== undefined && item.Lock !== null;
          const st = isCargoItem ? stCargo : stDefault;
          if (st !== "Offline" && st !== "Inactivated") {
            onlineIdSet.add(item.ID);
          }
        });
      }

      const filterNode = (node) => {
        const filteredNode = { ...node };

        if (node.vehicles && node.vehicles.length > 0) {
          filteredNode.vehicles = node.vehicles.filter((vehicle) => {
            const isCargoVehicle = vehicle.FCar?.TName === "JT701D";
            if (targetStatus === "Online") {
              return onlineIdSet.has(vehicle.id);
            } else {
              // For status map filtering, check cargo vs non-cargo
              return statusMap[targetStatus]?.some(
                (item) => item.ID === vehicle.id,
              );
            }
          });
        }

        if (node.children && node.children.length > 0) {
          filteredNode.children = node.children
            .map((child) => filterNode(child))
            .filter(
              (child) =>
                (child.vehicles && child.vehicles.length > 0) ||
                (child.children && child.children.length > 0),
            );
        }

        filteredNode.expanded = expandedNodes[node.key];
        return filteredNode;
      };

      return nodes
        .map((node) => filterNode(node))
        .filter(
          (node) =>
            (node.vehicles && node.vehicles.length > 0) ||
            (node.children && node.children.length > 0),
        );
    },
    [MonitorDetails, getVehicleStatus, statusMap, expandedNodes],
  );

  const filterHierarchyByVehicleName = useCallback((node, term) => {
    if (!term) return node;

    const lowerTerm = term.toLowerCase();
    const filteredVehicles = (node.vehicles || []).filter((v) =>
      (v.name || "").toLowerCase().includes(lowerTerm),
    );

    const filteredChildren = (node.children || [])
      .map((child) => filterHierarchyByVehicleName(child, term))
      .filter(Boolean);

    if (filteredVehicles.length > 0 || filteredChildren.length > 0) {
      return {
        ...node,
        vehicles: filteredVehicles,
        children: filteredChildren,
      };
    }

    return null;
  }, []);

  const buildHierarchyItems = useCallback(() => {
    const items = [];
    if (!JtVehicleDetails?.data) return items;

    const monitorMapById = new Map();
    MonitorDetails.forEach((device) => {
      if (device.ID) {
        monitorMapById.set(device.ID, device);
      }
    });

    const recomputeNodeCounts = (node) => {
      // Recursively recompute children first
      if (node.children?.length) {
        node.children = node.children.map(recomputeNodeCounts);
      }
      // Count all vehicles under this node (direct + from children)
      const directCount = node.vehicles?.length ?? 0;
      const childCount = (node.children || []).reduce(
        (sum, child) => sum + (child._totalVehicleCount ?? 0),
        0,
      );
      node._totalVehicleCount = directCount + childCount;
      // Rebuild display name with correct count
      node.name = `${node.name}【${node._totalVehicleCount}】`;
      return node;
    };

    const getVehicleStatusHelper = (vehicleId) => {
      const monitorData = monitorMapById.get(vehicleId);
      if (!monitorData)
        return { statusText: "Offline", statusColor: "#FF3B30" };

      const { Speed = 0, Vehicle, RT, Lon, Lat } = monitorData;
      const acc = Vehicle?.ACC ?? null;

      if (!RT) return { statusText: "Offline", statusColor: "#FF3B30" };

      const lastUpdate = new Date(RT).getTime();
      if (isNaN(lastUpdate))
        return { statusText: "Offline", statusColor: "#FF3B30" };

      const diffMinutes = (Date.now() - lastUpdate) / (1000 * 60);
      if (diffMinutes > 10)
        return { statusText: "Offline", statusColor: "#FF3B30" };
      if (!Lon || !Lat || Lon === 0 || Lat === 0)
        return { statusText: "Online", statusColor: "#34C759" };
      if (Speed > 0) return { statusText: "Moving", statusColor: "#34C759" };
      if (Speed === 0 && acc === 1)
        return { statusText: "Idle", statusColor: "#FF9500" };
      if (Speed === 0 && acc === 0)
        return { statusText: "Stationary", statusColor: "#C7C7CC" };

      return { statusText: "Online", statusColor: "#34C759" };
    };
    const getStatusText = (vehicleId) => {
      const monitorData = monitorMapById.get(vehicleId);
      if (!monitorData || !monitorData.RT)
        return { text: "Offline", color: "gray" };

      const { Speed = 0, Vehicle, RT } = monitorData;
      const acc = Vehicle?.ACC ?? null;
      const lastUpdate = new Date(RT).getTime();
      const diffMinutes = (Date.now() - lastUpdate) / (1000 * 60);

      if (diffMinutes > 10) {
        return { text: "Offline", color: "gray" };
      }

      return { text: "Online", color: "green" };
    };
    const getLockIcon = (vehicleId, isJT701D) => {
      if (!isJT701D) return null;
      const monitorData = monitorMapById.get(vehicleId);
      const lockStatus = monitorData?.Lock?.LS;
      const isLocked = lockStatus === 0;
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          {isLocked ? <Locked /> : <UnLocked />}
        </div>
      );
    };

    const getBatteryIcon = (vehicleId, isJT701D) => {
      if (!isJT701D) return null;
      const monitorData = monitorMapById.get(vehicleId);
      const batteryValue = monitorData?.Lock?.Bat;

      const icon =
        batteryValue === undefined || batteryValue === null ? (
          <Battery />
        ) : batteryValue < 20 ? (
          <LowBt />
        ) : (
          <Battery />
        );

      const color =
        batteryValue === undefined || batteryValue === null
          ? "#999999"
          : batteryValue < 20
            ? "#FF3B30"
            : batteryValue < 50
              ? "#333"
              : "#34C759";

      const displayValue =
        batteryValue === undefined || batteryValue === null
          ? "–"
          : `${batteryValue}%`;

      return (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          {icon}
          <span style={{ fontSize: 12, color }}>{displayValue}</span>
        </div>
      );
    };

    const getStatusIcon = (statusText) => {
      switch (statusText) {
        case "Moving":
          return <Moving />;
        case "Idle":
          return <Idle />;
        case "Stationary":
          return <Stationary />;
        default:
          return <Stationary />;
      }
    };

    const getTruckIcon = (fcar, statusText) => {
      if (!fcar) return <StationaryVehicle className="IconSize" />;
      switch (fcar.TName) {
        case "GP2000":
          switch (statusText) {
            case "Moving":
              return <MovingVehicle className="IconSize" />;
            case "Idle":
              return <IdleVehicle className="IconSize" />;
            case "Stationary":
            case "Offline":
            default:
              return <StationaryVehicle className="IconSize" />;
          }
        case "JT701D":
          return <LiveTrackone className="IconSizecontainer" />;
        default:
          return <StationaryVehicle className="IconSize" />;
      }
    };

    const StatusDot = ({ color }) => (
      <span className="status-dot" style={{ backgroundColor: color }} />
    );

    const buildNode = (node, level = 0) => {
      const nodeType =
        level === 0 ? "company" : level === 1 ? "subCompany" : "subSubCompany";
      // const nodeName = node.AName || node.FName || `Unknown ${nodeType}`;
      // Strip the 【N】 suffix from API name
      const stripCount = (name = "") => name.replace(/【\d+】/g, "").trim();
      const nodeName = stripCount(
        node.AName || node.FName || `Unknown ${nodeType}`,
      );

      const hierarchyNode = {
        type: nodeType,
        name: nodeName,
        key: node.FGUID,
        level: level,
        children: [],
        vehicles: [],
      };

      const children = node.FChild || [];
      children.forEach((child) => {
        if (child.FNType === 0 || child.FNType === 1) {
          const childName = child.AName || child.FName || "";

          if (childName.includes("default【")) {
            const vehicles = child.FChild || [];
            vehicles.forEach((v) => {
              if (v.FNType === 2) {
                const isJT701D = v.FCar?.TName === "JT701D";
                const vehicleId = v.FCar?.ID;
                const { statusText, statusColor } =
                  getVehicleStatusHelper(vehicleId);
                const statusIcon = getStatusIcon(statusText);

                hierarchyNode.vehicles.push({
                  type: "vehicle",
                  name: isJT701D
                    ? `${v.FCar?.ID || ""} (${v.FName || "Unknown Vehicle"})`
                    : v.FName || "Unknown Vehicle",
                  regNo: isJT701D
                    ? `${v.FCar?.ID || ""} (${v.FName || "Unknown Vehicle"})`
                    : v.FName || "Unknown Vehicle",
                  FGUID: v.FGUID,
                  FCar: v.FCar,
                  id: vehicleId,
                  Icon: getTruckIcon(v.FCar, statusText),
                  status: (
                    <StatusDot
                      color={statusText === "Offline" ? "#B7B7B7" : "#34C759"}
                    />
                  ),
                  statusColor: statusText === "Offline" ? "#5F6D8C" : "#34C759",
                  statusText: getStatusText(vehicleId),
                  stationary: statusIcon,
                  battery: getBatteryIcon(vehicleId, isJT701D),
                  lock: getLockIcon(vehicleId, isJT701D),
                });
              }
            });
          } else {
            const childNode = buildNode(child, level + 1);
            hierarchyNode.children.push(childNode);
          }
        } else if (child.FNType === 2) {
          const isJT701D = child.FCar?.TName === "JT701D";
          const vehicleId = child.FCar?.ID;
          const { statusText, statusColor } = getVehicleStatusHelper(vehicleId);
          const statusIcon = getStatusIcon(statusText);

          hierarchyNode.vehicles.push({
            type: "vehicle",
            name: isJT701D
              ? `${child.FCar?.ID || ""} (${child.FName || "Unknown Vehicle"})`
              : child.FName || "Unknown Vehicle",
            regNo: isJT701D
              ? `${child.FCar?.ID || ""} (${child.FName || "Unknown Vehicle"})`
              : child.FName || "Unknown Vehicle",
            FGUID: child.FGUID,
            FCar: child.FCar,
            id: vehicleId,
            Icon: getTruckIcon(child.FCar, statusText),
            status: (
              <StatusDot
                color={statusText === "Offline" ? "#B7B7B7" : "#34C759"}
              />
            ),
            statusColor: statusText === "Offline" ? "#5F6D8C" : "#34C759",
            statusText: getStatusText(vehicleId),
            stationary: statusIcon,
            battery: getBatteryIcon(vehicleId, isJT701D),
            lock: getLockIcon(vehicleId, isJT701D),
          });
        }
      });

      return hierarchyNode;
    };

    JtVehicleDetails.data.forEach((mainCompany) => {
      if (mainCompany.FNType === 0 || mainCompany.FNType === 1) {
        const companyNode = recomputeNodeCounts(buildNode(mainCompany, 0)); // AFTER
        items.push(companyNode);
      }
    });

    let workingItems = items;
    if (searchTerm && searchTerm.trim() !== "") {
      workingItems = workingItems
        .map((node) => filterHierarchyByVehicleName(node, searchTerm))
        .filter(Boolean);
    }

    return filterHierarchyByStatus(workingItems, selectedFilters);
  }, [
    JtVehicleDetails,
    MonitorDetails,
    searchTerm,
    selectedFilters,
    filterHierarchyByVehicleName,
    filterHierarchyByStatus,
  ]);

  const buildFilteredHierarchy = useCallback(
    (vehicleFilterFn) => {
      const items = [];
      if (!JtVehicleDetails?.data) return items;

      const monitorMapById = new Map();
      MonitorDetails.forEach((device) => {
        if (device.ID) monitorMapById.set(device.ID, device);
      });

      const recomputeNodeCounts = (node) => {
        // Recursively recompute children first
        if (node.children?.length) {
          node.children = node.children.map(recomputeNodeCounts);
        }
        // Count all vehicles under this node (direct + from children)
        const directCount = node.vehicles?.length ?? 0;
        const childCount = (node.children || []).reduce(
          (sum, child) => sum + (child._totalVehicleCount ?? 0),
          0,
        );
        node._totalVehicleCount = directCount + childCount;
        // Rebuild display name with correct count
        node.name = `${node.name}【${node._totalVehicleCount}】`;
        return node;
      };

      const getVehicleStatusHelper = (vehicleId) => {
        const monitorData = monitorMapById.get(vehicleId);
        if (!monitorData)
          return { statusText: "Offline", statusColor: "#FF3B30" };
        const { Speed = 0, Vehicle, RT, Lon, Lat } = monitorData;
        const acc = Vehicle?.ACC ?? null;

        if (!RT) return { statusText: "Offline", statusColor: "#FF3B30" };
        const lastUpdate = new Date(RT).getTime();
        if (isNaN(lastUpdate))
          return { statusText: "Offline", statusColor: "#FF3B30" };

        const diffMinutes = (Date.now() - lastUpdate) / (1000 * 60);
        if (diffMinutes > 10)
          return { statusText: "Offline", statusColor: "#FF3B30" };
        if (!Lon || !Lat || Lon === 0 || Lat === 0)
          return { statusText: "Online", statusColor: "#34C759" };
        if (Speed > 0) return { statusText: "Moving", statusColor: "#34C759" };
        if (Speed === 0 && acc === 1)
          return { statusText: "Idle", statusColor: "#FF9500" };
        if (Speed === 0 && acc === 0)
          return { statusText: "Stationary", statusColor: "#C7C7CC" };
        return { statusText: "Online", statusColor: "#34C759" };
      };

      const getBatteryIcon = (vehicleId, isJT701D) => {
        if (!isJT701D) return null;
        const monitorData = monitorMapById.get(vehicleId);
        const batteryValue = monitorData?.Lock?.Bat;

        const icon =
          batteryValue === undefined || batteryValue === null ? (
            <Battery />
          ) : batteryValue < 20 ? (
            <LowBt />
          ) : (
            <Battery />
          );
        const color =
          batteryValue === undefined || batteryValue === null
            ? "#999999"
            : batteryValue < 20
              ? "#FF3B30"
              : batteryValue < 50
                ? "#333"
                : "#34C759";
        const displayValue =
          batteryValue === undefined || batteryValue === null
            ? "–"
            : `${batteryValue}%`;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            {icon}
            <span style={{ fontSize: 12, color }}>{displayValue}</span>
          </div>
        );
      };

      const getLockIcon = (vehicleId, isJT701D) => {
        if (!isJT701D) return null;
        const monitorData = monitorMapById.get(vehicleId);
        const lockStatus = monitorData?.Lock?.LS;
        const isLocked = lockStatus === 0;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            {isLocked ? <Locked /> : <UnLocked />}
          </div>
        );
      };

      const getStatusIcon = (statusText) => {
        switch (statusText) {
          case "Moving":
            return <Moving />;
          case "Idle":
            return <Idle />;
          case "Stationary":
            return <Stationary />;
          default:
            return <Stationary />;
        }
      };

      const getTruckIcon = (fcar, statusText) => {
        if (!fcar) return <StationaryVehicle className="IconSize" />;
        switch (fcar.TName) {
          case "GP2000":
            switch (statusText) {
              case "Moving":
                return <MovingVehicle className="IconSize" />;
              case "Idle":
                return <IdleVehicle className="IconSize" />;
              default:
                return <StationaryVehicle className="IconSize" />;
            }
          case "JT701D":
            return <LiveTrackone className="IconSizecontainer" />;
          default:
            return <StationaryVehicle className="IconSize" />;
        }
      };
      const getStatusText = (vehicleId) => {
        const monitorData = monitorMapById.get(vehicleId);
        if (!monitorData || !monitorData.RT)
          return { text: "Offline", color: "gray" };

        const { Speed = 0, Vehicle, RT } = monitorData;
        const acc = Vehicle?.ACC ?? null;
        const lastUpdate = new Date(RT).getTime();
        const diffMinutes = (Date.now() - lastUpdate) / (1000 * 60);

        if (diffMinutes > 10) {
          return { text: "Offline", color: "gray" };
        }

        return { text: "Online", color: "green" };
      };
      const StatusDot = ({ color }) => (
        <span className="status-dot" style={{ backgroundColor: color }} />
      );

      const buildNode = (node, level = 0) => {
        const nodeType =
          level === 0
            ? "company"
            : level === 1
              ? "subCompany"
              : "subSubCompany";
        // const nodeName = node.AName || node.FName || `Unknown ${nodeType}`;
        // Strip the 【N】 suffix from API name
        const stripCount = (name = "") => name.replace(/【\d+】/g, "").trim();
        const nodeName = stripCount(
          node.AName || node.FName || `Unknown ${nodeType}`,
        );

        const hierarchyNode = {
          type: nodeType,
          name: nodeName,
          key: node.FGUID,
          level: level,
          children: [],
          vehicles: [],
        };

        (node.FChild || []).forEach((child) => {
          if (child.FNType === 0 || child.FNType === 1) {
            const childNode = buildNode(child, level + 1);
            if (childNode.vehicles.length || childNode.children.length)
              hierarchyNode.children.push(childNode);
          } else if (child.FNType === 2 && vehicleFilterFn(child.FCar)) {
            const vehicleId = child.FCar?.ID;
            const { statusText } = getVehicleStatusHelper(vehicleId);
            const statusIcon = getStatusIcon(statusText);
            const isJT701D = child.FCar?.TName === "JT701D";

            hierarchyNode.vehicles.push({
              type: "vehicle",
              name: isJT701D
                ? `${child.FCar?.ID || ""} (${child.FName || "Unknown Vehicle"})`
                : child.FName || "Unknown Vehicle",
              regNo: isJT701D
                ? `${child.FCar?.ID || ""} (${child.FName || "Unknown Vehicle"})`
                : child.FName || "Unknown Vehicle",
              FGUID: child.FGUID,
              FCar: child.FCar,
              id: child.FCar?.ID,
              Icon: getTruckIcon(child.FCar, statusText),
              status: (
                <StatusDot
                  color={statusText === "Offline" ? "#B7B7B7" : "#34C759"}
                />
              ),
              statusColor: statusText === "Offline" ? "#5F6D8C" : "#34C759",
              statusText: getStatusText(vehicleId),
              stationary: statusIcon,
              battery: getBatteryIcon(child.FCar?.ID, isJT701D),
              lock: isJT701D ? getLockIcon(child.FCar?.ID, isJT701D) : null,
            });
          }
        });
        return hierarchyNode;
      };

      JtVehicleDetails.data.forEach((mainCompany) => {
        if (mainCompany.FNType === 0 || mainCompany.FNType === 1) {
          const companyNode = buildNode(mainCompany, 0);
          // if (companyNode.vehicles.length || companyNode.children.length) items.push(companyNode);
          if (companyNode.vehicles.length || companyNode.children.length) {
            items.push(recomputeNodeCounts(companyNode));
          }
        }
      });

      let workingItems = items;
      if (searchTerm && searchTerm.trim() !== "") {
        workingItems = workingItems
          .map((node) => filterHierarchyByVehicleName(node, searchTerm))
          .filter(Boolean);
      }

      return filterHierarchyByStatus(workingItems, selectedFilters);
    },
    [
      JtVehicleDetails,
      MonitorDetails,
      searchTerm,
      selectedFilters,
      filterHierarchyByVehicleName,
      filterHierarchyByStatus,
    ],
  );

  const renderHierarchy = useCallback(
    (nodes, depth = 0) => {
      return nodes.map((node) => {
        const marginLeft = depth * 20;
        const isCompany = node.type === "company";
        const isSubCompany = node.type === "subCompany";
        const isExpanded = expandedNodes[node.key];

        return (
          <div key={node.key}>
            <div
              onClick={(e) => {
                e.stopPropagation();
                toggleExpand(node.key);
              }}
              className={
                isCompany
                  ? "company-node bold"
                  : isSubCompany
                    ? "subcompany-node"
                    : ""
              }
              style={{ marginLeft, cursor: "pointer" }}
            >
              <Checkbox
                checked={
                  getAllVehicleFGUIDs(node).length > 0 &&
                  getAllVehicleFGUIDs(node).every((id) =>
                    selectedFGUIDs.includes(id),
                  )
                }
                indeterminate={
                  getAllVehicleFGUIDs(node).some((id) =>
                    selectedFGUIDs.includes(id),
                  ) &&
                  !getAllVehicleFGUIDs(node).every((id) =>
                    selectedFGUIDs.includes(id),
                  )
                }
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => {
                  e.stopPropagation();
                  handleCompanyCheckbox(node, e.target.checked);
                }}
              />

              {isCompany ? (
                <GKPM className="company-icon" />
              ) : (
                <Drop className="subcompany-icon" />
              )}

              <span className="node-name">{node.name}</span>

              <GArrow
                className={`arrow-icon ${isExpanded ? "expanded" : "collapsed"}`}
              />
            </div>

            {isExpanded && node.vehicles?.length > 0 && (
              <div
                className="vehicle-list"
                style={{ marginLeft: marginLeft + 30, cursor: "pointer" }}
              >
                {node.vehicles.map((vehicle, index) => (
                  <div
                    key={vehicle.FGUID}
                    className="vehicle-item"
                    // ADD HOVER HANDLERS HERE
                    //                  onClick={(e) => {
                    //   e.stopPropagation();

                    //   // Find live data
                    //   const vehicleData = VehLivedetails.find(
                    //     (v) =>
                    //       String(v.FVehicleGUID) === String(vehicle.FGUID) ||
                    //       String(v.FAssetGUID) === String(vehicle.FGUID) ||
                    //       String(v.FGUID) === String(vehicle.FGUID)
                    //   );

                    //   if (vehicleData) {
                    //     setHoveredVehicle(vehicleData);
                    //     return;
                    //   }

                    //   const monitorData = MonitorDetails.find((m) => String(m.ID) === String(vehicle.id));

                    //   if (monitorData) {
                    //     setHoveredVehicle({
                    //       FGUID: vehicle.FGUID,
                    //       FVehicleGUID: vehicle.FGUID,
                    //       FAssetGUID: vehicle.FGUID,
                    //       FVehicleName: vehicle.name,
                    //       FLatitude: monitorData.Lat,
                    //       FLongitude: monitorData.Lon,
                    //       FSpeed: monitorData.Speed || 0,
                    //       FACC: monitorData.Vehicle?.ACC || 0,
                    //       FOnline: monitorData.RT ? 1 : 0,
                    //       FGPSTime: monitorData.RT,
                    //     });
                    //     return;
                    //   }

                    //   // fallback minimal data
                    //   setHoveredVehicle({
                    //     FGUID: vehicle.FGUID,
                    //     FVehicleGUID: vehicle.FGUID,
                    //     FAssetGUID: vehicle.FGUID,
                    //     FVehicleName: vehicle.name,
                    //   });
                    // }}
                    onClick={(e) => {
                      e.stopPropagation();

                      // PRIORITY 1: Try to find MonitorDetails first (most up-to-date)
                      const monitorData = MonitorDetails.find(
                        (m) => String(m.ID) === String(vehicle.id),
                      );

                      if (
                        monitorData &&
                        monitorData.Lat &&
                        monitorData.Lon &&
                        monitorData.Lat !== 0 &&
                        monitorData.Lon !== 0
                      ) {
                        setHoveredVehicle({
                          FGUID: vehicle.FGUID,
                          FVehicleGUID: vehicle.FGUID,
                          FAssetGUID: vehicle.FGUID,
                          FVehicleName: vehicle.name,
                          FLatitude: monitorData.Lat,
                          FLongitude: monitorData.Lon,
                          FSpeed: monitorData.Speed || 0,
                          FACC: monitorData.Vehicle?.ACC || 0,
                          FOnline: monitorData.RT ? 1 : 0,
                          FGPSTime: monitorData.RT,
                          FAssetTypeID:
                            vehicle.FCar?.TName === "JT701D" ? 3701 : 552,
                        });
                        return;
                      }

                      // PRIORITY 2: Try to find in VehLivedetails
                      const vehicleData = VehLivedetails.find(
                        (v) =>
                          String(v.FVehicleGUID) === String(vehicle.FGUID) ||
                          String(v.FAssetGUID) === String(vehicle.FGUID) ||
                          String(v.FGUID) === String(vehicle.FGUID),
                      );

                      if (vehicleData) {
                        setHoveredVehicle(vehicleData);
                        return;
                      }

                      // PRIORITY 3: Fallback to minimal data
                      console.warn(
                        `No coordinates found for vehicle ${vehicle.name}`,
                      );
                      setHoveredVehicle({
                        FGUID: vehicle.FGUID,
                        FVehicleGUID: vehicle.FGUID,
                        FAssetGUID: vehicle.FGUID,
                        FVehicleName: vehicle.name,
                      });
                    }}
                  >
                    <div className="vehicle-header">
                      <Checkbox
                        checked={selectedFGUIDs.includes(vehicle.FGUID)}
                        onClick={(e) => e.stopPropagation()}
                        onChange={async (e) => {
                          e.stopPropagation();
                          const isChecked = e.target.checked;
                          handleVehicleCheckbox(vehicle.FGUID, isChecked);

                          if (isChecked) {
                            await new Promise((resolve) =>
                              setTimeout(resolve, 100),
                            );
                            let fullVehicleData = VehLivedetails.find(
                              (v) =>
                                v.FVehicleGUID === vehicle.FGUID ||
                                v.FAssetGUID === vehicle.FGUID ||
                                v.FGUID === vehicle.FGUID,
                            );

                            if (!fullVehicleData) {
                              try {
                                await vehicleLiveLocation([vehicle.FGUID]);
                                await new Promise((resolve) =>
                                  setTimeout(resolve, 300),
                                );
                                fullVehicleData = VehLivedetails.find(
                                  (v) =>
                                    v.FVehicleGUID === vehicle.FGUID ||
                                    v.FAssetGUID === vehicle.FGUID ||
                                    v.FGUID === vehicle.FGUID,
                                );
                              } catch (error) {
                                console.error(
                                  "Error fetching vehicle location:",
                                  error,
                                );
                              }
                            }

                            if (fullVehicleData) {
                              setSelectedVehicleFromList(fullVehicleData);
                              setVehicleSelectionCounter((prev) => prev + 1);
                            } else {
                              const monitorData = MonitorDetails.find(
                                (m) => m.ID === vehicle.id,
                              );
                              if (
                                monitorData &&
                                monitorData.Lat &&
                                monitorData.Lon
                              ) {
                                const vehicleData = {
                                  FGUID: vehicle.FGUID,
                                  FVehicleGUID: vehicle.FGUID,
                                  FAssetGUID: vehicle.FGUID,
                                  FVehicleName: vehicle.name,
                                  FLatitude: monitorData.Lat,
                                  FLongitude: monitorData.Lon,
                                  FSpeed: monitorData.Speed || 0,
                                  FACC: monitorData.Vehicle?.ACC || 0,
                                  FOnline: monitorData.RT ? 1 : 0,
                                  FAssetTypeID:
                                    vehicle.FCar?.TName === "JT701D"
                                      ? 3701
                                      : 552,
                                  FGPSTime: monitorData.RT,
                                  FMileage: monitorData.Mileage,
                                  FBattery: monitorData.Lock?.Bat,
                                  FLockStatus: monitorData.Lock?.LS,
                                };
                                setSelectedVehicleFromList(vehicleData);
                                setVehicleSelectionCounter((prev) => prev + 1);
                              } else {
                                console.error(
                                  "No location data available for this vehicle",
                                );
                                message.warning(
                                  "Vehicle location data not available",
                                );
                              }
                            }
                          }
                        }}
                      />

                      {vehicle.Icon}
                      <span
                        className="vehicle-name"
                        style={{ color: vehicle.statusColor }}
                      >
                        {vehicle.regNo}
                      </span>
                      <div className="StatusWrapper">
                        {vehicle.status}
                        <span
                          className="StatusTooltip"
                          style={{ color: vehicle.statusText.color }}
                        >
                          {vehicle.statusText.text}
                        </span>
                      </div>
                    </div>

                    <div className="vehicle-details">
                      <span>{vehicle.stationary ?? ""}</span>
                      <span className="separator">|</span>
                      {vehicle.battery && (
                        <>
                          <span>{vehicle.battery}</span>
                          <span className="separator">|</span>
                        </>
                      )}
                      {vehicle.lock && <span>{vehicle.lock}</span>}
                    </div>

                    {index !== node.vehicles.length - 1 && (
                      <hr className="vehicle-divider" />
                    )}
                  </div>
                ))}
              </div>
            )}

            {isExpanded && node.children?.length > 0 && (
              <div style={{ marginLeft: marginLeft + 10, cursor: "pointer" }}>
                {renderHierarchy(node.children, depth + 1)}
              </div>
            )}
          </div>
        );
      });
    },
    [
      expandedNodes,
      selectedFilters,
      searchTerm,
      toggleExpand,
      selectedFGUIDs,
      getAllVehicleFGUIDs,
      handleCompanyCheckbox,
      handleVehicleCheckbox,
      VehLivedetails,
      MonitorDetails,
      vehicleLiveLocation,
      setSelectedVehicleFromList,
      setVehicleSelectionCounter,
    ],
  );

  const handleTabChange = useCallback(
    (key) => {
      setActiveTab(key);

      let hierarchyItems = [];
      if (key === "All") {
        hierarchyItems = buildHierarchyItems();
      } else if (key === "TrackRight AI") {
        hierarchyItems = buildFilteredHierarchy(
          (fcar) => fcar?.TName === "GP2000",
        );
      } else if (key === "TrackRight AI Cargo") {
        hierarchyItems = buildFilteredHierarchy(
          (fcar) => fcar?.TName === "JT701D",
        );
      }
      expandAllNodes(hierarchyItems);
    },
    [buildHierarchyItems, buildFilteredHierarchy, expandAllNodes],
  );

  const getVisibleVehicleFGUIDs = useCallback((nodes) => {
    let fguids = [];

    const traverse = (nodeList) => {
      nodeList.forEach((node) => {
        // Add vehicles from this node
        if (node.vehicles && node.vehicles.length > 0) {
          fguids = fguids.concat(node.vehicles.map((v) => v.FGUID));
        }

        // Traverse children
        if (node.children && node.children.length > 0) {
          traverse(node.children);
        }
      });
    };

    traverse(nodes);
    return fguids;
  }, []);

  // FIXED:
const All = useMemo(() => {
  const items = buildHierarchyItems();
  return (
    <div className="tab-content-wrapper">
      <div className="map_container_checkboxsubcontainer">
        <div>{tabScopedStatusCounts.total} Total</div>
        <div className="mapbox_online_icon">{tabScopedStatusCounts.online} Online</div>
        <div>{tabScopedStatusCounts.offline} Offline</div>
        <div className="mapbox_online_icon">{tabScopedStatusCounts.moving} Moving</div>
      </div>
      <div className="map_container_hierarchy">
        {Array.isArray(items) && items.length > 0 ? (
          renderHierarchy(items)
        ) : (
          <div className="no-results-message">No results matching your query</div>
        )}
      </div>
    </div>
  );
}, [
  buildHierarchyItems,
  renderHierarchy,
  tabScopedStatusCounts,  // ← ADDED (replaces Monitorcount)
  expandedNodes,
  selectedFGUIDs,
  searchTerm,
  selectedFilters,
]);

  // TrackrightAi memo - replace the status bar div:
  const TrackrightAi = useMemo(() => {
    const hierarchyItems = buildFilteredHierarchy(
      (fcar) => fcar?.TName === "GP2000",
    );
    return (
      <div className="tab-content-wrapper">
        <div className="map_container_checkboxsubcontainer">
          {/* BEFORE (wrong): */}
          {/* <div>{JtVehicleDetails?.data?.[0]?.FVCount ?? 0} Total</div> */}
          {/* <div className="mapbox_online_icon">{Monitorcount?.data?.FOnline ?? 0} Online</div> */}
          {/* <div>{Monitorcount?.data?.FOffline ?? 0} Offline</div> */}
          {/* <div className="mapbox_online_icon">{Monitorcount?.data?.FRun ?? 0} Moving</div> */}

          {/* AFTER (correct): */}
          <div>{tabScopedStatusCounts.total} Total</div>
          <div className="mapbox_online_icon">
            {tabScopedStatusCounts.online} Online
          </div>
          <div>{tabScopedStatusCounts.offline} Offline</div>
          <div className="mapbox_online_icon">
            {tabScopedStatusCounts.moving} Moving
          </div>
        </div>
        <div className="map_container_hierarchy">
          {hierarchyItems.length > 0 ? (
            renderHierarchy(hierarchyItems)
          ) : (
            <div className="no-results-message">No vehicles found</div>
          )}
        </div>
      </div>
    );
  }, [
    buildFilteredHierarchy,
    renderHierarchy,
    tabScopedStatusCounts,
    expandedNodes,
    selectedFGUIDs,
    searchTerm,
    selectedFilters,
  ]);

  const TrackrightAiCargo = useMemo(() => {
    const hierarchyItems = buildFilteredHierarchy(
      (fcar) => fcar?.TName === "JT701D",
    );
    return (
      <div className="tab-content-wrapper">
        <div className="map_container_checkboxsubcontainer">
          <div>{tabScopedStatusCounts.total} Total</div>
          <div className="mapbox_online_icon">
            {tabScopedStatusCounts.online} Online
          </div>
          <div>{tabScopedStatusCounts.offline} Offline</div>
          <div className="mapbox_online_icon">
            {tabScopedStatusCounts.moving} Moving
          </div>
        </div>
        <div className="map_container_hierarchy">
          {hierarchyItems.length > 0 ? (
            renderHierarchy(hierarchyItems)
          ) : (
            <div className="no-results-message">No Device found</div>
          )}
        </div>
      </div>
    );
  }, [
    buildFilteredHierarchy,
    renderHierarchy,
    tabScopedStatusCounts,
    expandedNodes,
    selectedFGUIDs,
    searchTerm,
    selectedFilters,
  ]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
    const liveCargoRead = useMemo(
    () => hasPermission("LIVE", "L_AIC"),
    [reduxPermissions],
  );
  const liveAIRead = useMemo(
    () => hasPermission("LIVE", "L_AI"),
    [reduxPermissions],
  );
  const tabs = useMemo(() => {
    const hasAITrack = subscriptionList.includes("LIVE") && liveAIRead;
    const hasAICargo = subscriptionList.includes("LIVE") && liveCargoRead;

    const tabList = [];
    if (hasAITrack && hasAICargo) tabList.push("All");
    if (hasAITrack) tabList.push("TrackRight AI");
    if (hasAICargo) tabList.push("TrackRight AI Cargo");

    return tabList;
  }, [subscriptionList]);

  const items = useMemo(() => {
    const allItems = [
      {
        key: "All",
        label: "All",
        children: All,
      },
      {
        key: "TrackRight AI",
        label: "TrackRight AI",
        children: TrackrightAi,
      },
      {
        key: "TrackRight AI Cargo",
        label: "TrackRight AI Cargo",
        children: TrackrightAiCargo,
      },
    ];
    // Filter items to only include tabs that should be shown
    return allItems.filter((item) => tabs.includes(item.key));
  }, [tabs, All, TrackrightAi, TrackrightAiCargo]);

  const defaultTab = useMemo(() => {
    return tabs.length > 0 ? tabs[0] : "All";
  }, [tabs]);

  const unifiedVehicleData = useMemo(() => {
    if (!VehLivedetails || VehLivedetails.length === 0) {
      return [];
    }

    const monitorMap = new Map();
    MonitorDetails.forEach((monitor) => {
      if (monitor.ID) {
        monitorMap.set(String(monitor.ID), monitor);
      }
    });

    return VehLivedetails.map((vehicle) => {
      let monitorData = null;
      // Try matching by FAssetID
      if (vehicle.FAssetID) {
        monitorData = monitorMap.get(String(vehicle.FAssetID));
      }
      // ALWAYS use MonitorDetails coordinates if available and valid
      if (
        monitorData &&
        monitorData.Lat &&
        monitorData.Lon &&
        monitorData.Lat !== 0 &&
        monitorData.Lon !== 0
      ) {
        return {
          ...vehicle,
          FLatitude: monitorData.Lat,
          FLongitude: monitorData.Lon,
          FSpeed: monitorData.Speed || 0,
          FACC: monitorData.Vehicle?.ACC || 0,
          FOnline: monitorData.RT ? 1 : 0,
          FGPSTime: monitorData.RT,
          FMileage: monitorData.Mileage || vehicle.FMileage,
          FGPSSignal: monitorData.GSS,
          FCellSignal: monitorData.CSS,
        };
      }
      // Fallback to original vehicle data if no valid monitor data
      console.warn(
        `No valid MonitorDetails found for vehicle ${vehicle.FVehicleName || vehicle.FVehicleGUID}`,
      );
      return vehicle;
    });
  }, [VehLivedetails, MonitorDetails]);

  useEffect(() => {
    dashboardCount();
    fetchAllDetails();
  }, [dashboardCount, fetchAllDetails]);

  useEffect(() => {
    if (defaultExpandedDoneRef.current) return;
    let hierarchyItems = [];
    if (activeTab === "All") {
      hierarchyItems = buildHierarchyItems();
    } else if (activeTab === "TrackRight AI") {
      hierarchyItems = buildFilteredHierarchy(
        (fcar) => fcar?.TName === "GP2000",
      );
    } else if (activeTab === "TrackRight AI Cargo") {
      hierarchyItems = buildFilteredHierarchy(
        (fcar) => fcar?.TName === "JT701D",
      );
    }
    if (Array.isArray(hierarchyItems) && hierarchyItems.length > 0) {
      expandAllNodes(hierarchyItems);
      defaultExpandedDoneRef.current = true; // prevent future automatic overwrites
    }
  }, [
    activeTab,
    buildHierarchyItems,
    buildFilteredHierarchy,
    expandAllNodes,
    JtVehicleDetails?.data,
    JtDeviceDetails?.data,
  ]);

  useEffect(() => {
    let timeoutId;
    let isMounted = true;

    const fetchLive = async () => {
      if (!isMounted) return;
      if (selectedFGUIDs?.length > 0) {
        try {
          await vehicleLiveLocation(selectedFGUIDs);
        } catch {}
      } else {
        setVehLiveDetails([]);
        setDeviceLiveDetails([]);
      }
      if (isMounted) timeoutId = setTimeout(fetchLive, 5000);
    };

    timeoutId = setTimeout(fetchLive, 1000);
    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [selectedFGUIDs, activeTab, vehicleLiveLocation]);

  useEffect(() => {
    let timeoutId;
    let isMounted = true;

    const fetchAllData = async () => {
      if (!isMounted) return;
      try {
        await Promise.all([jointechVehicledetails(), jointechDevicedetails()]);
      } catch {}
      if (isMounted) timeoutId = setTimeout(fetchAllData, 5000);
    };

    timeoutId = setTimeout(fetchAllData, 1000);
    return () => {
      isMounted = false;
      clearTimeout(timeoutId);
    };
  }, [jointechVehicledetails, jointechDevicedetails]);

  useEffect(() => {
    if (JtVehicleDetails?.data || JtDeviceDetails?.data) {
      const getAllVehicles = (items) => {
        return items.flatMap((item) => {
          if (item.FChild && item.FChild.length > 0) {
            return getAllVehicles(item.FChild);
          }
          return item ? [item] : [];
        });
      };

      const flatVehicles = JtVehicleDetails?.data
        ? getAllVehicles(JtVehicleDetails.data)
        : [];
      const allAssets = [
        ...flatVehicles.map((v) => ({ ...v, type: "vehicle" })),
        ...(JtDeviceDetails?.data || []).map((d) => ({ ...d, type: "device" })),
      ];

      let activeAssets = allAssets.filter((a) => {
        if (a.type === "vehicle") {
          return a.FCar && a.FCar.GUID;
        } else if (a.type === "device") {
          return a.DeviceId;
        }
        return false;
      });

      const seenVehicleIDs = new Set();
      activeAssets = activeAssets.filter((a) => {
        if (a.type === "vehicle") {
          if (seenVehicleIDs.has(a.FCar.ID)) {
            return false;
          } else {
            seenVehicleIDs.add(a.FCar.ID);
            return true;
          }
        }
        return true;
      });

      const inactiveAssets = allAssets.filter((a) => !activeAssets.includes(a));
      const activeFGUIDs = activeAssets
        .map((a) => {
          if (a.type === "vehicle") return a.FCar?.GUID;
          return a.FGUID;
        })
        .filter(Boolean);

      if (activeFGUIDs.length > 0) {
        fetchMonitorDevice(activeFGUIDs);
      }

      setMonitorcount((prev) => ({
        ...prev,
        data: {
          ...prev?.data,
          All: allAssets.length,
          Active: activeAssets.length,
          Inactive: inactiveAssets.length,
        },
      }));
    }
  }, [JtVehicleDetails, JtDeviceDetails, fetchMonitorDevice]);

  useEffect(() => {
    if (MonitorDetails?.length) {
      const counts = getFilterCounts(MonitorDetails);
      setFiltercount(counts);
    }
  }, [MonitorDetails, getFilterCounts]);

  useEffect(() => {
    const map = {
      Online: [],
      Offline: [],
      Idle: [],
      Stationary: [],
      Moving: [],
      NotPositioned: [],
      Locked: [],
      Unlocked: [],
      Inactivated: [],
    };

    MonitorDetails.forEach((item) => {
      // Detect cargo device: has Lock field populated
      const isCargoItem = item.Lock !== undefined && item.Lock !== null;
      const st = getVehicleStatus(item, 10, isCargoItem); // ← pass correct flag
      if (!map[st]) map[st] = [];
      map[st].push(item);
    });

    setStatusMap(map);
  }, [MonitorDetails, getVehicleStatus]);

  // Default selection of checkboxes
  useEffect(() => {
    if (isInitialSelectionDone) return;

    if (JtVehicleDetails?.data && JtVehicleDetails.data.length > 0) {
      const collectAllFGUIDsFromRawData = (nodes) => {
        let ids = [];
        nodes.forEach((node) => {
          if (node.FNType === 2 && node.FGUID) {
            ids.push(node.FGUID);
          }
          if (node.FChild && node.FChild.length > 0) {
            ids = ids.concat(collectAllFGUIDsFromRawData(node.FChild));
          }
        });
        return ids;
      };

      const allFGUIDs = collectAllFGUIDsFromRawData(JtVehicleDetails.data);
      setSelectedFGUIDs(allFGUIDs);
      setIsInitialSelectionDone(true);
    }
  }, [JtVehicleDetails, isInitialSelectionDone]);

  useEffect(() => {
    let hierarchyItems = [];

    if (activeTab === "All") {
      hierarchyItems = buildHierarchyItems();
    } else if (activeTab === "TrackRight AI") {
      hierarchyItems = buildFilteredHierarchy(
        (fcar) => fcar?.TName === "GP2000",
      );
    } else if (activeTab === "TrackRight AI Cargo") {
      hierarchyItems = buildFilteredHierarchy(
        (fcar) => fcar?.TName === "JT701D",
      );
    }

    const visibleIds = getVisibleVehicleFGUIDs(hierarchyItems);
    setVisibleFGUIDs(visibleIds);
  }, [
    activeTab,
    searchTerm,
    selectedFilters,
    JtVehicleDetails,
    MonitorDetails,
    buildHierarchyItems,
    buildFilteredHierarchy,
    getVisibleVehicleFGUIDs,
  ]);
  useEffect(() => {
    if (tabs.length > 0 && !tabs.includes(activeTab)) {
      setActiveTab(tabs[0]);
    }
  }, [tabs, activeTab]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target;
      if (
        (filterRef.current && filterRef.current.contains(target)) ||
        (filterToggleRef.current && filterToggleRef.current.contains(target))
      ) {
        return;
      }
      setFilterVisible(false);
    };

    // use 'click' so the element's onClick runs before this handler
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (hoveredVehicle) {
      const timer = setTimeout(() => {
        setHoveredVehicle(null);
      }, 2000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [hoveredVehicle]);

  const markerKeyRef = useRef(null);
  const isHoveredRef = useRef(false);

  const handleContainerHover = useCallback(
    (deviceArray) => {
      // clear hover state if no hoveredVehicle
      if (!hoveredVehicle) {
        isHoveredRef.current = false;
        markerKeyRef.current = null;
        return;
      }

      if (!Array.isArray(deviceArray)) {
        // nothing to match against
        isHoveredRef.current = false;
        markerKeyRef.current = null;
        return;
      }

      const hoveredId = String(
        hoveredVehicle.FVehicleGUID ||
          hoveredVehicle.FAssetGUID ||
          hoveredVehicle.FGUID ||
          hoveredVehicle.ID ||
          "",
      );

      const match = deviceArray.find((d) => {
        const id = String(
          d.FVehicleGUID || d.FAssetGUID || d.FGUID || d.ID || "",
        );
        if (id === hoveredId) {
        }
        return id === hoveredId;
      });

      if (match) {
        markerKeyRef.current = String(
          match.FAssetGUID ||
            match.FVehicleGUID ||
            match.FGUID ||
            match.ID ||
            "",
        );
        isHoveredRef.current = true;
      } else {
        markerKeyRef.current = null;
        isHoveredRef.current = false;
      }
    },
    [hoveredVehicle],
  );

  return (
    <LiveTrackStyle>
      <Row>
        <Col style={{ position: "relative" }} xl={24} xxl={24}>
          <div>
            <Spin spinning={handleLoading} tip="Loading...">
              <LiveMapcomponent
                className="liveTrackMap_container_two"
                trackLink={true}
                LiveVehicleDetailMap={unifiedVehicleData}
                LiveDeviceDetailMap={DeviceLiveDetails}
                MonitorDetails={MonitorDetails}
                hoveredVehicle={hoveredVehicle}
                conatinericon={true}
                selectedVehicleFromList={selectedVehicleFromList}
                vehicleSelectionCounter={vehicleSelectionCounter}
                visibleFGUIDs={visibleFGUIDs}
                handleContainerHover={handleContainerHover}
                markerKeyRef={markerKeyRef}
                isHoveredRef={isHoveredRef}
                activeTab={activeTab}
              />
              {/* 
              <DraggablePopup
                              LiveVehicleDetailMap={unifiedVehicleData}
                                              visibleFGUIDs={visibleFGUIDs}
                                                              MonitorDetails={MonitorDetails}


/> */}
            </Spin>

            <div>
              <Card className="card_container" headStyle={{ display: "none" }}>
                <div className="container_three">
                  <div className="left-section">
                    <Input
                      placeholder="Search"
                      allowClear
                      className="search-input"
                      prefix={
                        <SearchOutlined
                          style={{ color: "rgba(0,0,0,.25)", fontSize: "20px" }}
                        />
                      }
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <div className="right-section">
                    <Badge count={""}>
                      <div
                        className="Iconbg"
                        ref={filterToggleRef}
                        onClick={() => setFilterVisible((prev) => !prev)}
                      >
                        <img
                          className="filter-icon-img"
                          src={FilterIcon}
                          alt="Filter Icon"
                        />
                      </div>
                    </Badge>
                    {filterVisible && (
                      <div ref={filterRef} className="filter-popup">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          {filters.map((filter) => (
                            <div
                              key={filter.key}
                              onClick={() => toggleFilter(filter.key)}
                              className={`filter-option ${selectedFilters.includes(filter.key) ? "active" : ""}`}
                            >
                              {filter.key} ({filter.count})
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="custom_dashboard_ai">
                  <Tab
                    className="custom_dashboard_ai_tab"
                    items={items}
                    onChange={handleTabChange}
                    activeKey={activeTab}
                    defaultActiveKey={defaultTab}
                  />
                </div>
              </Card>
            </div>
          </div>
        </Col>
      </Row>
    </LiveTrackStyle>
  );
};
export default LiveTrack;